import React from 'react'
import QueueAnim from 'rc-queue-anim'
import Button from '@material-ui/core/Button'
import { injectIntl } from 'react-intl'
import * as ROUTE from 'constants/appRouting'
import messages from 'routes/Exception/translate'

function Error404(props) {
  const {
    intl: { formatMessage },
    history,
  } = props

  const goBack = () => {
    history.replace(ROUTE.APPS)
  }

  return (
    <div className="err-container text-center">
      <div className="err">
        <div className="err-top">{formatMessage(messages.error)}</div>
        <h1>404</h1>
        <h2 className="err-text">{formatMessage(messages.notFoundMessage)}</h2>
      </div>

      <div className="err-body">
        <Button onClick={goBack} variant="contained">
          {formatMessage(messages.goBack)}
        </Button>
      </div>
    </div>
  )
}

function Page(props) {
  return (
    <div className="page-err">
      <QueueAnim type="bottom">
        <div key="1">
          <Error404 {...props} />
        </div>
      </QueueAnim>
    </div>
  )
}

export default injectIntl(Page)
